import React from 'react'
import { components as SelectComponents } from 'react-select'
import { Images } from '@/constants'
import styles from './styles.scss'

const customStyles = {
  valueContainer: provided => ({
    ...provided,
    padding: '0px',
  }),
  option: (provided, state) => ({
    ...provided,
    color: styles.black,
    minHeight: '46px',
    fontSize: styles.standardFont,
    lineHeight: '20px',
    fontWeight: 'lighter',
    margin: 'auto',
    paddingTop: '14px',
    paddingBottom: '14px',
    backgroundColor: state.isFocused ? `${styles.orange7Opacity}` : styles.white,
    borderBottom: `1px solid ${styles.lightestGrey}`,
    ':active': {
      backgroundColor: styles.orange7,
      color: styles.white,
    },
  }),
  control: (provided, state) => ({
    ...provided,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderRadius: 0,
    boxShadow: null,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: state.isFocused ? styles.darkerGrey : styles.lightGrey,
    fontWeight: 500,
    fontSize: styles.standardFont,
    flex: 1,
    color: styles.orange8,
    background: 'transparent',
    ':hover': {
      borderBottomColor: styles.lightestGrey,
    },
    maxWidth: '100%',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    padding: '0px',
  }),
  placeholder: provided => ({
    ...provided,
    color: styles.darkGrey,
    fontWeight: 500,
    fontSize: styles.standardFont,
    marginLeft: '2px',
    marginRight: 0,
  }),
  singleValue: provided => ({
    ...provided,
    color: styles.orange8,
  }),
  menu: provided => ({
    ...provided,
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    borderRadius: 0,
    boxShadow: null,
    borderStyle: 'solid',
    borderColor: styles.lightGrey,
    backgroundColor: styles.white,
    borderWidth: '1px',
    overflow: 'auto',
  }),
  menuList: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
    '::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: styles.orange7,
    },
    '::-webkit-scrollbar': {
      width: '5px',
      borderRadius: '2.5px',
      backgroundColor: 'transparent',
    },
  }),
}

const DropdownIndicator = props =>
  SelectComponents.DropdownIndicator && (
    <SelectComponents.DropdownIndicator {...props}>
      <img className={styles.accessory} src={Images.triangle} alt="dropdownIndicator" />
    </SelectComponents.DropdownIndicator>
  )

export const customComponents = { DropdownIndicator, IndicatorSeparator: null }

export default customStyles
